import { TooltipComponent } from '@/src/components/layout';
import { Icon } from '@/src/components/ui';
import { Button } from '@workspace/ui/components/button';
import { redirect } from 'next/navigation';
import { PartnerCheckmark } from '../../settings/components/PartnerBadge';

type Props = {
  authorName: string;
  authorLink: string;
  isPartner?: boolean;
};

export const UnlockButton = ({ authorLink, authorName, isPartner }: Props) => {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/60">
      <Icon name="lock" className="text-black size-6 mb-2" />
      <TooltipComponent
        text={`Unlock content by subscribing to ${authorName}`}
        className="md:max-w-40 md:max-h-20 h-fit line-clamp-4"
      >
        <Button
          variant="secondary"
          size="sm"
          className="text-sm transition px-3"
          onClick={() => redirect(`/${authorLink}`)}
        >
          Unlock
        </Button>
      </TooltipComponent>
    </div>
  );
};

export const UserLink = ({ authorLink, authorName, isPartner }: Props) => {
  return (
    <span
      className="font-medium text-black/40 md:text-sm text-xs hover:underline hover:cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        window.location.href = `/${authorLink}`;
      }}
    >
      {authorName}
      {isPartner && <PartnerCheckmark className="inline-block size-3" />}
    </span>
  );
};
